import React from 'react'
import { dMmm, getXlsx, cancelToken } from '@fareye/utils'
import { Button, toast } from '@fareye/ui'
import { downloadToCSV, useTranslation } from '@fareye/common'
import queryString from 'query-string'
import { LANGUAGE_STRINGS, TRN_CONSTANTS } from '@fareye/configs'

interface IDownloadExcelButton {
  apiUrl: string
  fileName: string
  isDisabled?: boolean
}

export function DownloadExcelButton({
  apiUrl,
  fileName,
  isDisabled = false
}: IDownloadExcelButton) {
  const isDisabledForDateRange = React.useMemo(() => {
    if (apiUrl?.split('?')?.[1]) {
      const searchParams: any = queryString.parse(apiUrl.split('?')[1])
      const startTime = new Date(searchParams?.start_date).getTime()
      const endTime = new Date(searchParams?.end_date).getTime()
      if (
        startTime &&
        endTime &&
        (endTime - startTime) / 1000 / 60 / 60 / 24 > TRN_CONSTANTS.maxDownloadDays
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }, [apiUrl])
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const { t } = useTranslation()

  const source = cancelToken().source()
  async function downloadCSV() {
    try {
      setDownloadLoading(true)
      const response = await getXlsx(apiUrl, source.token)
      const reportName = response.headers['content-disposition']?.split('=')[1]
      const { data } = response
      downloadToCSV({
        data,
        fileName: `${reportName || fileName}-${dMmm()}`,
        type: 'text/zip',
        extension: 'zip'
      })
      setDownloadLoading(false)
    } catch (ex:any) {
      setDownloadLoading(false)
      toast.error(t('Something went wrong ....'))
      console.warn(ex)
    }
  }
  return (
    <span
      title={
        isDisabledForDateRange
          ? t(LANGUAGE_STRINGS.MAX_DOWNLOAD, {
              MAX_DOWNLOAD: TRN_CONSTANTS.maxDownloadDays
            })
          : t('Export as Excel')
      }
    >
      <Button
        variant="primary m"
        disabled={isDisabled || isDisabledForDateRange}
        onClick={() => downloadCSV()}
        isLoading={downloadLoading}
        style={{ marginLeft: '20px' }}
      >
        {t('Export as Excel')}
      </Button>
    </span>
  )
}
